module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/stream-browserify/~/readable-stream/passthrough.js
 ** module id = 4198
 ** module chunks = 0
 **/